module.exports = __webpack_public_path__ + "img/placeholder-a4.f179b8c4.jpg";